export default __webpack_public_path__ + "static/media/quickbase-icon.b2f066b2.svg";